var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"centered":"","scrollable":"","title":"Full Text","modal-class":_vm.theme,"body-class":"modal__confirm","size":"xl","ok-only":"","ok-title":"Close"}},[_vm._v("\n\t"+_vm._s(_vm.text)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }